export default __webpack_public_path__ + "static/media/NFTART.851aa397.png";